import classNames from 'classnames';
import type { CSSProperties } from 'react';

import { textOn } from '@/utils/color';

/**
 * A segment as a tag, filled with the colour the team picked for it (SEG-1…3), its
 * text white or black to suit that colour (textOn). With no colour (a deleted
 * segment, an activity no segment is named after) it is a plain grey tag. The name
 * always shows: the colour alone never identifies a segment.
 */
export const SegmentChip = ({ name, color, title, onRemove }: { name: string; color?: string; title?: string; onRemove?: () => void }) => (
  <span
    title={title ?? name}
    // Filled with the segment's colour, and its shadow glows in it (.pill, src/index.css).
    style={color ? ({ '--tag-color': color } as CSSProperties) : undefined}
    className={classNames('pill inline-flex max-w-full items-center rounded-pill px-2.5 py-1 text-xs font-medium', color ? textOn(color) : 'text-fg')}
  >
    <span className="min-w-0 truncate">{name}</span>
    {onRemove && (
      <button type="button" onClick={onRemove} aria-label={`Remove ${name}`}
        // 44px to tap on a phone (UI-1), without making the chip itself taller.
        className="-my-3 -mr-2.5 ml-0.5 flex h-11 w-9 shrink-0 items-center justify-center rounded-full opacity-75 hover:opacity-100 md:my-0 md:-mr-1 md:h-auto md:w-auto md:px-1">×</button>
    )}
  </span>
);
